export const calendarEventConstants = {
  // create calendar event
  CREATE_CALENDAR_EVENT_ACTION_REQUEST: "CREATE_CALENDAR_EVENT_ACTION_REQUEST",
  CREATE_CALENDAR_EVENT_ACTION_SUCCESS: "CREATE_CALENDAR_EVENT_ACTION_SUCCESS",
  CREATE_CALENDAR_EVENT_ACTION_FAILURE: "CREATE_CALENDAR_EVENT_ACTION_FAILURE",

  // update calendar event
  UPDATE_CALENDAR_EVENT_ACTION_REQUEST: "UPDATE_CALENDAR_EVENT_ACTION_REQUEST",
  UPDATE_CALENDAR_EVENT_ACTION_SUCCESS: "UPDATE_CALENDAR_EVENT_ACTION_SUCCESS",
  UPDATE_CALENDAR_EVENT_ACTION_FAILURE: "UPDATE_CALENDAR_EVENT_ACTION_FAILURE",

  // delete calendar event
  DELETE_CALENDAR_EVENT_ACTION_REQUEST: "DELETE_CALENDAR_EVENT_ACTION_REQUEST",
  DELETE_CALENDAR_EVENT_ACTION_SUCCESS: "DELETE_CALENDAR_EVENT_ACTION_SUCCESS",
  DELETE_CALENDAR_EVENT_ACTION_FAILURE: "DELETE_CALENDAR_EVENT_ACTION_FAILURE",

  // get calendar event details
  GET_CALENDAR_EVENT_DETAILS_ACTION_REQUEST:
    "GET_CALENDAR_EVENT_DETAILS_ACTION_REQUEST",
  GET_CALENDAR_EVENT_DETAILS_ACTION_SUCCESS:
    "GET_CALENDAR_EVENT_DETAILS_ACTION_SUCCESS",
  GET_CALENDAR_EVENT_DETAILS_ACTION_FAILURE:
    "GET_CALENDAR_EVENT_DETAILS_ACTION_FAILURE",

  // get calendar event lists
  GET_CALENDAR_EVENT_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_EVENT_LISTS_ACTION_REQUEST",
  GET_CALENDAR_EVENT_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_EVENT_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_EVENT_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_EVENT_LISTS_ACTION_FAILURE",

  // get calendar event lists
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_REQUEST",
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_FAILURE",

  // create candidate data
  GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_REQUEST",
  GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_FAILURE",

  // create candidate data
  GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_REQUEST",
  GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_FAILURE",

  // get calendar event lists
  GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_REQUEST",
  GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_FAILURE",

  // get availability
  GET_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST:
    "GET_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST",
  GET_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    "GET_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS",
  GET_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE:
    "GET_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE",

  // update calendar event availability
  CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST:
    "CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST",
  CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    "CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS",
  CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE:
    "CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE",

  // update calendar event availability
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST",
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS",
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE",

  // get calendar event link
  GET_CALENDAR_EVENT_LINK_ACTION_REQUEST:
    "GET_CALENDAR_EVENT_LINK_ACTION_REQUEST",
  GET_CALENDAR_EVENT_LINK_ACTION_SUCCESS:
    "GET_CALENDAR_EVENT_LINK_ACTION_SUCCESS",
  GET_CALENDAR_EVENT_LINK_ACTION_FAILURE:
    "GET_CALENDAR_EVENT_LINK_ACTION_FAILURE",

  // get calendar event link
  ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_REQUEST:
    "ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_REQUEST",
  ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_SUCCESS:
    "ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_SUCCESS",
  ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_FAILURE:
    "ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_FAILURE",
};
